

export const FACILITIES_TYPES = {
    REGIONAL_DIRECTORATE: 'Regional Directorate',
    DISTRICT_DIRECTORATE: 'District Directorate',
    HEALTH_CARE_FACILITY: 'Health Care Facility',

} as const;

export type IFacilityType = (typeof FACILITIES_TYPES)[keyof typeof FACILITIES_TYPES];
export const facilityTypeList = Object.values(FACILITIES_TYPES).map(entry => entry);